import { Chart, registerables } from 'chart.js';
import ChartAnnotations from 'chartjs-plugin-annotation';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import ChartJSTrendline from 'chartjs-plugin-trendline';

// Removing ...registerables from here will break all the charts
const reg = registerables ? registerables : []; // Fix for jest

/**
 * Single registration point for every Chart.js plugin used across the design system.
 *
 * The plugins are rendered in the order of registration
 *
 * @see indicatorAnnotations.ts
 */
Chart.register(...reg, ChartJSTrendline, ChartAnnotations, ChartDataLabels);
